'use es6';

export const CODE_PANES = 'CODE_PANES';
export const SIDEBAR = 'SIDEBAR';
export const HTML = 'HTML';
export const CSS = 'CSS';
export const JS = 'JS';